import { DateTime } from 'luxon';
import { Backend } from '@generated-backend-types';
import WeekDayEnum = Backend.App.Enums.WeekDayEnum;

/**
 * Maps a Luxon DateTime to its WeekDayEnum value in a locale-independent way.
 *
 * `DateTime.weekday` is always 1 (Monday) through 7 (Sunday) regardless of the
 * active locale, unlike `weekdayLong` which would return e.g. "Montag" in a
 * German locale and break comparisons against the English enum values.
 */
const WEEK_DAYS: readonly WeekDayEnum[] = [
  WeekDayEnum.MONDAY,
  WeekDayEnum.TUESDAY,
  WeekDayEnum.WEDNESDAY,
  WeekDayEnum.THURSDAY,
  WeekDayEnum.FRIDAY,
  WeekDayEnum.SATURDAY,
  WeekDayEnum.SUNDAY,
];

export function weekDayEnumFromDateTime(day: DateTime): WeekDayEnum {
  return WEEK_DAYS[day.weekday - 1];
}
